'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weekBefore;


// WEBPACK FOOTER //
// ./~/sugar-date/number/weekBefore.js